export const formatCurrency = (amount: number = 0) => {
  return Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    .format(amount)
};
